// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.ai-chat-grafico {
  margin: 8px 0 0;
  padding: 8px 10px;
  border: 1px solid var(--ion-color-step-150, rgba(128, 128, 128, 0.25));
  border-radius: 8px;
  background: var(--ion-background-color, transparent);
}

.ai-chat-grafico__testata {
  display: flex;
  align-items: center;
  gap: 4px;
}

.ai-chat-grafico__titolo {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ai-chat-grafico__azioni {
  display: flex;
  flex-shrink: 0;
}

.ai-chat-grafico__area {
  position: relative;
  height: 220px;
}

.ai-chat-grafico--grande {
  height: 100%;
  margin: 0;
  padding: 12px 16px;
  border: none;
  display: flex;
  flex-direction: column;
}
.ai-chat-grafico--grande .ai-chat-grafico__area {
  flex: 1;
  height: auto;
  min-height: 300px;
}
.ai-chat-grafico--grande .ai-chat-grafico__titolo {
  font-size: 16px;
  white-space: normal;
}

.ai-chat-grafico__kpi {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
  gap: 8px;
  padding: 4px 0;
}

.ai-chat-grafico__tessera {
  display: flex;
  flex-direction: column;
  padding: 8px;
  border-radius: 6px;
  background: var(--ion-color-light, rgba(128, 128, 128, 0.08));
}

.ai-chat-grafico__tessera-etichetta {
  font-size: 12px;
  color: var(--ion-color-medium);
}

.ai-chat-grafico__tessera-valore {
  font-size: 20px;
}

.ai-chat-grafico__riga {
  padding: 4px 0;
}

.ai-chat-grafico__riga-testa {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
}

.ai-chat-grafico__riga-valori {
  color: var(--ion-color-medium);
  white-space: nowrap;
}

.ai-chat-grafico__barra {
  display: flex;
  height: 8px;
  margin-top: 3px;
  border-radius: 4px;
  overflow: hidden;
  background: var(--ion-color-step-150, rgba(128, 128, 128, 0.2));
}

.ai-chat-grafico__barra-fatto {
  background: var(--ion-color-success);
}

.ai-chat-grafico__barra-scarti {
  background: var(--ion-color-danger);
}

.ai-chat-grafico__piede {
  display: block;
  margin-top: 4px;
  font-size: 11px;
  color: var(--ion-color-medium);
}

.ai-chat-grafico__dati {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/_components/ai-chat/ai-chat-grafico/ai-chat-grafico.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,sEAAA;EACA,kBAAA;EACA,oDAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;AACF;;AAEA;EACE,YAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,OAAA;EACA,YAAA;EACA,iBAAA;AACJ;AAEE;EACE,eAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,0DAAA;EACA,QAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,6DAAA;AADF;;AAIA;EACE,eAAA;EACA,8BAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;AADF;;AAIA;EACE,8BAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAIA;EACE,mCAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,8BAAA;AADF;;AAKA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAFF","sourcesContent":[":host {\n  display: block;\n}\n\n.ai-chat-grafico {\n  margin: 8px 0 0;\n  padding: 8px 10px;\n  border: 1px solid var(--ion-color-step-150, rgba(128, 128, 128, 0.25));\n  border-radius: 8px;\n  background: var(--ion-background-color, transparent);\n}\n\n.ai-chat-grafico__testata {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.ai-chat-grafico__titolo {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ai-chat-grafico__azioni {\n  display: flex;\n  flex-shrink: 0;\n}\n\n.ai-chat-grafico__area {\n  position: relative;\n  height: 220px;\n}\n\n.ai-chat-grafico--grande {\n  height: 100%;\n  margin: 0;\n  padding: 12px 16px;\n  border: none;\n  display: flex;\n  flex-direction: column;\n\n  .ai-chat-grafico__area {\n    flex: 1;\n    height: auto;\n    min-height: 300px;\n  }\n\n  .ai-chat-grafico__titolo {\n    font-size: 16px;\n    white-space: normal;\n  }\n}\n\n.ai-chat-grafico__kpi {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));\n  gap: 8px;\n  padding: 4px 0;\n}\n\n.ai-chat-grafico__tessera {\n  display: flex;\n  flex-direction: column;\n  padding: 8px;\n  border-radius: 6px;\n  background: var(--ion-color-light, rgba(128, 128, 128, 0.08));\n}\n\n.ai-chat-grafico__tessera-etichetta {\n  font-size: 12px;\n  color: var(--ion-color-medium);\n}\n\n.ai-chat-grafico__tessera-valore {\n  font-size: 20px;\n}\n\n.ai-chat-grafico__riga {\n  padding: 4px 0;\n}\n\n.ai-chat-grafico__riga-testa {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 12px;\n}\n\n.ai-chat-grafico__riga-valori {\n  color: var(--ion-color-medium);\n  white-space: nowrap;\n}\n\n.ai-chat-grafico__barra {\n  display: flex;\n  height: 8px;\n  margin-top: 3px;\n  border-radius: 4px;\n  overflow: hidden;\n  background: var(--ion-color-step-150, rgba(128, 128, 128, 0.2));\n}\n\n.ai-chat-grafico__barra-fatto {\n  background: var(--ion-color-success);\n}\n\n.ai-chat-grafico__barra-scarti {\n  background: var(--ion-color-danger);\n}\n\n.ai-chat-grafico__piede {\n  display: block;\n  margin-top: 4px;\n  font-size: 11px;\n  color: var(--ion-color-medium);\n}\n\n// Tabella per i lettori di schermo, nascosta alla vista.\n.ai-chat-grafico__dati {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
